import { render, staticRenderFns } from "./seasonprices.vue?vue&type=template&id=80fc8906&"
import script from "./seasonprices.vue?vue&type=script&lang=js&"
export * from "./seasonprices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('80fc8906')) {
      api.createRecord('80fc8906', component.options)
    } else {
      api.reload('80fc8906', component.options)
    }
    module.hot.accept("./seasonprices.vue?vue&type=template&id=80fc8906&", function () {
      api.rerender('80fc8906', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2KDnMqZ6kHvfE/JS/comp/seasonprices.vue"
export default component.exports